import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { NgLetModule } from 'ng-let';
import { TranslateModule } from '@ngx-translate/core';

import { FormControlsModule } from '../admin/form-controls/form-controls.module';
import { PageLayoutModule } from '../global/page-layout';
import { MarkdownModule } from '../global/markdown';
import { UserModule } from '../global/userService';
import { ModalModule } from '../global/modal/modal.module';

import { EventListPage } from './event-list.page';
import { EventCreatePage } from './event-create.page';
import { EventDetailPage } from './event-detail.page';
import { EventEditPage } from './event-edit.page';
import { EventManageRegistrationsPage } from './event-manage-registrations.page';
import { EventManagePage } from './event-manage.page';
import { RoundManagementPage } from './round-management.page';
import { VisibleCoOrganisersPipe } from './event-detail.page';
import { EventPointsPipe } from './event-list.page';
import {
    CountryNamePipe,
    ListSlotLabelPipe,
    PairingModeKeyPipe,
    PublishStatusColourPipe,
    PublishStatusKeyPipe,
    ResultSummaryPipe,
    VisibilityKeyPipe
} from './event.pipes';
import { PhotoCaptureComponent } from '../global/images';
import { AdminPanelComponent } from '../global/debug/admin-panel.component';
import { EventService } from './event.service';
import { CoOrganiserPickerComponent } from './co-organiser-picker.component';
import { OrganiserApplicationPage } from './organiser-application.page';
import { EventDayPage } from './event-day.page';
import { EventScheduleComponent } from './event-schedule.component';
import { EventPackPage } from './event-pack.page';
import { EventPackDocumentComponent } from './event-pack-document.component';
import { EventResultFormComponent } from './event-result-form.component';
import { RefreshButtonComponent } from './refresh-button.component';
import { StandingsPage } from './standings.page';
import { RegistrationDetailsFormComponent } from './registration-details-form.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        RouterModule,
        PageLayoutModule,
        FormControlsModule,
        UserModule,
        NgLetModule,
        TranslateModule,
        CoOrganiserPickerComponent,
        VisibleCoOrganisersPipe,
        EventPointsPipe,
        CountryNamePipe,
        ListSlotLabelPipe,
        PairingModeKeyPipe,
        PublishStatusColourPipe,
        PublishStatusKeyPipe,
        ResultSummaryPipe,
        VisibilityKeyPipe,
        PhotoCaptureComponent,
        AdminPanelComponent,
        ModalModule,
        RegistrationDetailsFormComponent,
        MarkdownModule
    ],
    declarations: [
        EventListPage,
        EventCreatePage,
        EventDetailPage,
        EventPackPage,
        EventPackDocumentComponent,
        EventEditPage,
        EventManageRegistrationsPage,
        EventManagePage,
        RoundManagementPage,
        OrganiserApplicationPage,
        EventDayPage,
        EventScheduleComponent,
        EventResultFormComponent,
        RefreshButtonComponent,
        StandingsPage
    ],
    exports: [
        EventListPage,
        EventCreatePage,
        EventDetailPage,
        EventPackPage,
        EventPackDocumentComponent,
        EventEditPage,
        EventManageRegistrationsPage,
        EventManagePage,
        RoundManagementPage,
        OrganiserApplicationPage,
        EventDayPage,
        EventScheduleComponent,
        EventResultFormComponent,
        RefreshButtonComponent,
        StandingsPage,
        RegistrationDetailsFormComponent
    ],
    providers: [EventService]
})
export class EventModule {}
